import session from '@/shared/session'

// initial state
const state = {
	current : {},
}

// getters
const getters = {}

// actions
const actions = {
	warmupsOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/warmups/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	warmupsDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/warmups/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	warmupCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/warmups/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	warmupUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/warmups/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	warmupRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/warmups/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterWarmups ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/warmups/get_filtered_warmups/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    warmupStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/warmups/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	activeWarmups({ commit }) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/warmups/get_active_warmups/', {
				headers: {
					"Authorization": "Token " + localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data;
				resolve(data);
			})
			.catch(errors => {
				resolve(errors.response.data);
			});
		});
	},	
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
